// src/components/EditDialog.js
import React, { useState, useEffect, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useCarContext } from '../../components/Context/CarContext';

const EditDialogModel = ({
  open,
  handleClose,
  type, // 'brand' or 'model'
  currentData,

  handleSave,
}) => {
    const { brands  } = useCarContext();
  const [name, setName] = useState('');
    const [Id, setId] = useState('');
    const [BrandId, setBrandId] = useState('');
    const selectedBrandRef = useRef('');
    
  useEffect(() => {
     
    if (currentData) {
      setName(currentData.name || '');
        setId(currentData.id || '');
        setBrandId(currentData.brandId || '');
       
    }
  }, [currentData]);

  const onSave = () => {
    if (type === 'model') {
        if (name.trim() === '' || Id === '') {
        alert('Model name and Brand selection cannot be empty.');
        return;
      }
       
        handleSave({ ...currentData, name: name.trim(), id: Id,brandId:selectedBrandRef.current.value });
      }

    handleClose();
  };
    
    

  

  return (
    <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Edit {type === 'brand' ? 'Brand' : type === 'model' ? 'Model' : type === 'body' ? 'Body Type':'Unknown'}</DialogTitle>
      <DialogContent>
        <TextField
                  label={`${type === 'brand' ? 'Brand' : type === 'model' ? 'Model' : type === 'body' ? 'Body Type' : 'Unknown'} Name`}
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          margin="dense"
        />
        
              <FormControl variant="outlined" fullWidth>
                  <InputLabel id="select-brand-label">Select Brand</InputLabel>
                  <Select
                      labelId="select-brand-label"
                      inputRef={selectedBrandRef}
                      label="Select Brand"
                      value={BrandId}
                      onChange={(e) => setBrandId(e.target.value)}
                  >
                      {brands.map((brand) => (
                          <MenuItem key={brand.id} value={brand.id}>
                              {brand.name}
                          </MenuItem>
                      ))}
                  </Select>
              </FormControl>
       
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={onSave}
          color="primary"
          variant="contained"
          disabled={type === 'brand' ? name.trim() === '' : name.trim() === '' || Id === ''}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDialogModel;
